import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Auth } from 'aws-amplify';

import { UserService } from '../../../core/api/user.service';
import { passwordMatchValidator, passwordPolicyValidator } from '../../../shared/lib/validators';
import { ToastLevel } from '../../../shared/models/toast-message.module';
import { ToastService } from '../../../shared/services/toast.service';
import { SpinnerService } from '../../../shared/spinner/spinner.service';
import * as fromApp from '../../../store';
import { AbstractAuthComponent } from '../abstract-auth.component';
import { AuthMode } from '../auth.component';

@Component({
  selector: 'fc-auth-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['../auth.component.scss'],
})
export class ResetPasswordComponent extends AbstractAuthComponent {
  resetPasswordForm: FormGroup = new FormGroup(
    {
      newPassword: new FormControl(null, [Validators.required, passwordPolicyValidator]),
      verificationCode: new FormControl(null, [Validators.required]),
      verifyPassword: new FormControl(null, [Validators.required, passwordPolicyValidator]),
    },
    { validators: [passwordMatchValidator] }
  );
  showNewPassword: boolean = false;
  showVerifyPassword: boolean = false;

  constructor(
    readonly spinnerService: SpinnerService,
    readonly store: Store<fromApp.AppState>,
    readonly userService: UserService,
    readonly toastService: ToastService
  ) {
    super();
  }

  resetPassword() {
    if (this.email) {
      this.spinnerService.show('reset-password-spinner');
      Auth.forgotPasswordSubmit(
          this.email.toLowerCase(),
          this.resetPasswordForm.value.verificationCode,
          this.resetPasswordForm.value.newPassword
        )
        .then(_cognitoResponse => {
          this.cognitoError = false;
          this.password = this.resetPasswordForm.value.newPassword;
          this.authMode = AuthMode.login;
          this.toastService.sendMessage(
            'Password reset successful',
            ToastLevel.SUCCESS,
            5000,
            'Please login with your new password'
          );
        })
        .catch(_err => {
          if (_err.name === 'LimitExceededException') {
            this.errorMessage =
              'Password reset attempts have exceeded limit; please try again after some time has passed.';
          } else {
            this.errorMessage = _err.message;
          }
          this.toastService.sendMessage(this.errorMessage || '', ToastLevel.WARN, 5000);
          this.cognitoError = true;
        })
        .finally(() => {
          this.spinnerService.hide('reset-password-spinner');
        });
    }
  }
}
